import
  React
from 'react';

import
  PropTypes
from 'prop-types';

import {
  Text,
  VFillContainer
} from '@vodacom/web-common';

import {
  CustomColors
} from '../../../../constants';

import {
  TextRow
} from 'components';

export const DetailCard = (props) => {

  return (

    <VFillContainer
      boxSizing={'border-box'}
      width={'100%'}
      margin={props.margin}
      backgroundColor={CustomColors.White}
      borderRadius={'4px'}
      padding={'24px 20px'}
      boxShadow={`0px 5px 15px 0px ${CustomColors.TransparentBlack1}`}>

      <Text
        fontWeight={'bold'}
        color={CustomColors.Grey9}
        fontSize={'18px'}>

        {'Voucher Details'}
      </Text>

      <TextRow
        margin={'24px 0 8px'}
        rightFontWeight={'normal'}
        leftText={'Payment method:'}
        rightText={props.paymentMethod}/>

      <TextRow
        rightFontWeight={'normal'}
        leftText={'Date of purchase:'}
        rightText={props.purchaseDate}/>

      <TextRow
        rightFontWeight={'normal'}
        leftText={'Payment due:'}
        rightText={props.paymentDue}/>

      <TextRow
        rightFontWeight={'normal'}
        leftText={'Outstanding amount:'}
        rightText={props.outstandingAmount}/>

      <TextRow
        rightFontWeight={'normal'}
        leftText={'Paid amount:'}
        rightText={props.paidAmount}/>

      <TextRow
        rightFontWeight={'normal'}
        leftText={'Additional fees:'}
        rightText={props.feeAmount}/>

      <TextRow
        margin={'16px 0 0'}
        leftText={'Total:'}
        leftFontColor={CustomColors.Black}
        leftFontWeight={'bold'}
        rightFontColor={CustomColors.Black}
        rightFontWeight={'bold'}
        rightText={props.total}/>

    </VFillContainer>
  );
};

DetailCard.propTypes = {
  paymentMethod: PropTypes.string,
  purchaseDate: PropTypes.string,
  paymentDue: PropTypes.string,
  outstandingAmount: PropTypes.string,
  paidAmount: PropTypes.string,
  feeAmount: PropTypes.string,
  total: PropTypes.string
};

DetailCard.defaultProps = {
  paymentMethod: 'Advance',
  purchaseDate: '8 Feb 2020',
  paymentDue: '15 Feb 2020',
  outstandingAmount: 'R35',
  paidAmount: 'R40',
  feeAmount: 'R5',
  total: 'R80'
};
